const FRENCH_MONTHS: Record<string, number> = {
  janvier: 1,
  fevrier: 2,
  février: 2,
  mars: 3,
  avril: 4,
  mai: 5,
  juin: 6,
  juillet: 7,
  aout: 8,
  août: 8,
  septembre: 9,
  octobre: 10,
  novembre: 11,
  decembre: 12,
  décembre: 12,
  janv: 1,
  fevr: 2,
  févr: 2,
  avr: 4,
  juil: 7,
  sept: 9,
  oct: 10,
  nov: 11,
  dec: 12,
  déc: 12,
};

const DATE_RE = /(\d{1,2})\s+([a-zà-ÿ.]+?)\s+(\d{4})/;

/**
 * Parses common French registrar date formats into a midnight-local Date.
 * Returns null when the input cannot be confidently parsed.
 *
 * Supported shapes (any leading non-digit content like a weekday is ignored;
 * any trailing time + timezone like "16:25 CET" is discarded):
 *   - "28 janvier 2002 16:25 CET"        (DNSBelgium long form)
 *   - "30 novembre 2025 11:04 CET"       (DNSBelgium long form)
 *   - "28 janvier 2002"                  (DNSBelgium long form, date only)
 *   - "11 juin 2026"                     (GoDaddy short form, full month)
 *   - "14 avr. 2027" / "2 sept. 2026"    (GoDaddy short form, abbreviated)
 *   - "1 févr. 2027" / "11 déc. 2026"    (GoDaddy short form, with diacritics)
 *   - "mer. 11 juin 2026"                (GoDaddy short form, with weekday prefix)
 *
 * Time-of-day and timezone are intentionally discarded. The returned Date is
 * set to 00:00:00 in the runtime's local timezone — the modal then formats it
 * to "YYYY-MM-DD" for display and submission.
 */
export function parseRegistrarDate(input: string): Date | null {
  if (typeof input !== 'string' || input.trim() === '') {
    return null;
  }

  const normalized = input.trim().toLowerCase();
  const match = DATE_RE.exec(normalized);
  if (match === null) {
    return null;
  }

  const day = Number(match[1]);
  const monthToken = match[2].replace(/\.$/, '');
  const year = Number(match[3]);

  const monthIndex = FRENCH_MONTHS[monthToken];
  if (monthIndex === undefined) {
    return null;
  }

  if (day < 1 || day > 31) {
    return null;
  }

  const d = new Date(year, monthIndex - 1, day);
  if (d.getFullYear() !== year || d.getMonth() !== monthIndex - 1 || d.getDate() !== day) {
    return null;
  }

  return d;
}
